export const serverUrl = 'https://api.way-to-vegan.com';
//export const serverUrl = "http://localhost:8080";
